import { EdpUser } from "@edp-models/user.model";
import { UserNotification } from "@edp-models/user-notification.model";
import { UserLevelStatus } from "@edp-models/user-level.model";
import { ProfileStatus } from "@edp-models/profile-status.model";

export interface IUserState {
    user: EdpUser;
    notifications: {
        list: UserNotification[];
        totalNotViewed: number;
        lastAPIError: Error;
    };
    onboarding: boolean;
    levelStatus: UserLevelStatus;
    isUserEdpE: boolean;
    celebrationZs: number;
    lastCelebrationZs: number;
    profileStatus: ProfileStatus;
}

export const initialUserState: IUserState = {
    user: null,
    notifications: {
        list: [],
        totalNotViewed: 0,
        lastAPIError: null,
    },
    onboarding: true,
    levelStatus: null,
    isUserEdpE: false,
    celebrationZs: 0,
    lastCelebrationZs: 0,
    profileStatus: null,
};
